var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCartSuccessMobile = function SvgIconCartSuccessMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46 40a6 6 0 1 1 12 0zm-4 0h-6a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h32a2 2 0 0 0 2-2V42a2 2 0 0 0-2-2h-6c0-5.523-4.477-10-10-10s-10 4.477-10 10m4 8a6 6 0 1 0 12 0h4c0 5.523-4.477 10-10 10s-10-4.477-10-10z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 57.5,
    y: 59.5,
    rx: 8.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388E3C",
    d: "M66.5 74.667a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334m-.665-4 4.714-4.714-.943-.943-3.77 3.771-1.886-1.885-.943.942z"
  })));
};
export default SvgIconCartSuccessMobile;